import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";
import { aggregateItems, grandTotal, mergedOrderNos } from "./mergeItems";

const Receipt = () => {
  const { id } = useParams();
  const [receiveData, setReceiveData] = useState({});

  const fetchData = () => {
    Http.get("/merge-invoice/" + id).then((res) => {
      setReceiveData(res.data);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const print = () => {
    window.print();
  };

  const items = aggregateItems(receiveData);
  const distributor = receiveData.distributor;

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <style>
          {`
              @media print {
                  body * { visibility: hidden; font-size:10px;}
                  .no-print { visibility: hidden !important; }
                  #printable-content, #printable-content * { visibility: visible; }
                  #printable-content { position: absolute; left: 0; top: 0; width: 100%; }
                  .main-card { padding: 0px; }
                  .am-pagebody { padding: 0px; }
                  .am-mainpanel { margin-top: 0px; }
                  .signature_section .table td{ border-bottom: 0;}
              }
              .main-card { padding: 40px; }
            `}
        </style>

        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Merge Invoice Receipt</h5>
          </div>
          <div className="am-pagebody">
            <div className="card main-card">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 padding">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg text-right">
                        <Link className="no-print btn-sm ms-1 btn btn-info" onClick={print}>
                          Print
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card" id="printable-content">
                  <div className="row">
                    <div className="col-md-12">
                      <table className="table" width="100%">
                        <tbody>
                          <tr>
                            <td width="100%" align="center">
                              <img src="/ldl-logo.png" alt="Logo" style={{ width: "30%" }} />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <table className="table" width="100%">
                        <tbody>
                          <tr>
                            <td width="18%">
                              <strong>Customer Name</strong>
                              <br />
                              <strong>Customer Id</strong>
                              <br />
                              <strong>Address</strong>
                              <br />
                              <strong>Invoice Nos</strong>
                            </td>
                            <td width="47%">
                              : {distributor ? distributor.name : ""} <br />: {distributor ? distributor.code : ""} <br />:{" "}
                              {distributor ? distributor.godown_address : ""} <br />: {mergedOrderNos(receiveData)}
                            </td>
                            <td width="35%" align="right">
                              Merge No. : {receiveData.receipt_no}
                              <br />
                              Date : {receiveData.date}
                              <br />
                              Vehicle No. : {receiveData.vehicle_number}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <table className="table" width="100%">
                        <tbody>
                          <tr>
                            <td align="center">
                              <h4>
                                <u>Merge Invoice</u>
                              </h4>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <table className="table table-bordered table-sm" width="100%">
                        <tbody>
                          <tr>
                            <td>Sl.</td>
                            <td>Product Name</td>
                            <td>Pack Size</td>
                            <td>Total Qty</td>
                            <td>Rate</td>
                            <td>Amount</td>
                          </tr>
                          {items.map((item, index) => (
                            <tr key={item.product_id}>
                              <td>{index + 1}</td>
                              <td>{item.product ? item.product.name : ""}</td>
                              <td align="right">{item.product ? item.product.pack_size : ""}</td>
                              <td align="right">{item.invQty}</td>
                              <td align="right">{item.rate}</td>
                              <td align="right">{item.price.toFixed(2)}</td>
                            </tr>
                          ))}
                          <tr>
                            <td colSpan="5" align="right">
                              <b>Grand Total</b>
                            </td>
                            <td align="right">
                              <b>{grandTotal(items).toFixed(2)}</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row mt-5">
                    <div className="col-md-12 signature__section">
                      <table className="table table-sm" width="100%">
                        <tbody>
                          <tr>
                            <td style={{ textAlign: "center", border: "0" }}>
                              <span>
                                ..............................
                                <br />
                                Received By
                              </span>
                            </td>
                            <td style={{ textAlign: "center", border: "0" }}>
                              <span>
                                ..............................
                                <br />
                                Prepared By
                              </span>
                            </td>
                            <td style={{ textAlign: "center", border: "0" }}>
                              <span>
                                ..............................
                                <br />
                                Checked By
                              </span>
                            </td>
                            <td style={{ textAlign: "center", border: "0" }}>
                              <span>
                                ..............................
                                <br />
                                Approved By
                              </span>
                            </td>
                            <td style={{ textAlign: "center", border: "0" }}>
                              <span>
                                ..............................
                                <br />
                                Depot In-Charge
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt;
